module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA/0lEQVRYR+2W6w2CQBCEZyqRDrQEO9ASLAE7sAO1A+kAK1A7wA6wA61gzSVH4uPgbgMHJrK/l5kv++KIgYMD+2ME+KqAiKQAFpFacyS5e9V2ASwBzCIBFCTzRoBIxrWy4xCOFWhVARFJAEwUg3sjWfrW0Kxg8rkuLhN7M7YKgIzkygcwB3ACcAawJlkoDNSprkNUAVRiBwtyV6sHfBACYGSM+YbkPkBTlRIK8LAAb3dc5VSTHAKQAUhJ9t6CizXufQiHXUNNX+0hMscoNErvIQpV6iqv1SnuAmIE+L0KiIh5lE676K9D4+p9lNpfrIGIEbn3WR7DtUnz92bg7yrwBOSXVCGtUZf9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/show.png
// module id = gQKk
// module chunks = 42